<script setup lang="ts">
import { computed } from 'vue';
import type { EntitySummary } from '../types/entities';

const props = withDefaults(defineProps<{
  entity: Pick<EntitySummary, 'id' | 'title' | 'profileImageData' | 'status'>;
  size?: 'xs' | 'sm' | 'md' | 'lg';
}>(), { size: 'sm' });

const initials = computed(() => props.entity.title.trim().split(/\s+/).slice(0, 2).map((part) => part[0]?.toLocaleUpperCase('de-DE') ?? '').join('') || '?');
</script>

<template>
  <span class="entity-portrait" :class="[`size-${size}`, { empty: !entity.profileImageData, archived: entity.status === 'archived', deleted: entity.status === 'deleted' }]" :title="entity.status === 'deleted' ? 'Entität gelöscht' : entity.title" aria-hidden="true">
    <img v-if="entity.profileImageData && entity.status !== 'deleted'" :src="entity.profileImageData" alt="" draggable="false" />
    <span v-else>{{ entity.status === 'deleted' ? '×' : initials }}</span>
  </span>
</template>

<style scoped>
.entity-portrait{--portrait-size:34px;display:inline-grid;place-items:center;flex:0 0 var(--portrait-size);width:var(--portrait-size);height:var(--portrait-size);overflow:hidden;border:2px solid var(--ui-border-strong);border-radius:50%;color:var(--ui-text-soft);background:radial-gradient(circle at 35% 28%,var(--ui-surface-3),var(--ui-surface-1));box-shadow:0 0 0 2px var(--ui-surface-2),0 0 13px color-mix(in srgb,var(--ui-accent) 22%,transparent);font-size:calc(var(--portrait-size) * .28);font-weight:850;line-height:1}
.entity-portrait.size-xs{--portrait-size:25px;border-width:1px;box-shadow:0 0 0 1px var(--ui-surface-2)}
.entity-portrait.size-md{--portrait-size:48px}
.entity-portrait.size-lg{--portrait-size:68px;border-width:3px;box-shadow:0 0 0 3px var(--ui-surface-2),0 0 20px color-mix(in srgb,var(--ui-accent) 28%,transparent)}
.entity-portrait img{width:100%;height:100%;object-fit:cover;user-select:none}
.entity-portrait.archived{filter:saturate(.45);opacity:.76}
.entity-portrait.deleted{border-color:var(--ui-danger-border);color:var(--ui-danger-text);box-shadow:none}
</style>
